import type { AgentRunListItem } from '@fos/shared/contracts/agents';
import { DelegateToClaudeDialog } from '../../../agents/components/DelegateToClaudeDialog';

/**
 * „Zleć Claude” z karty zadania (MVP §13, Etap 8; Fala 9 — wcześniej „Zleć AI”, DECISIONS 2026-10-07 „Zmiany w kodzie
 * i operacje robi tylko Claude”): instrukcja, wykonawca (Claude na moim komputerze — lokalny runner, albo sesja Claude
 * przez MCP), repozytorium (domyślnie z projektu), branch bazowy, limity, komenda testów i narzędzia MCP dla agenta.
 * Wspólny dialog: `DelegateToClaudeDialog` (features/agents). Usługa: `agents.create`.
 *
 * Kompozycja: przycisk „Zleć Claude” w nagłówku karty zadania otwiera ten dialog (`task` = TaskDetail lub podzbiór).
 */
export interface AssignAiTask {
  id: string;
  number: number;
  title: string;
  descriptionMd?: string | null;
  project: { id: string; name: string } | null;
  client: { id: string; name: string } | null;
}

export function AssignAiDialog({
  task,
  open,
  onOpenChange,
  onCreated,
}: {
  task: AssignAiTask;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreated?: (run: AgentRunListItem) => void;
}) {
  return (
    <DelegateToClaudeDialog
      target={{
        taskId: task.id,
        contextLabel: `#${task.number} ${task.title}${task.client ? ` · ${task.client.name}` : ''}`,
        projectName: task.project?.name ?? null,
      }}
      open={open}
      onOpenChange={onOpenChange}
      onCreated={onCreated}
    />
  );
}
